import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Button from '../Input/Button';
import ConsentConflictModal from './ConsentConflictModal';

import {PAGE_NAMES} from '../../pages.js';
import {getSettings, saveSettings} from '../../actions/index';

export class CancelSaveButton extends React.Component {
    static displayName = 'Usersettings.CancelSaveButton';

    constructor(props) {
        super(props);
        this.state = { isConsentConflictModalVisible: false };
    }

    save = () => {
        const userConsents = this.props.settings.userConsents? this.props.settings.userConsents : this.props.settings.consents.userConsents;
        if (userConsents) {
            const isRequiredConsentsWithoutAcceptance = userConsents.some(x => x.required && !x.accepted);
            if (isRequiredConsentsWithoutAcceptance) {
                this.setState({ isConsentConflictModalVisible: true });
            } else {
                this.props.saveSettings(PAGE_NAMES.PRIVACY);
            }
        } else {
            this.props.saveSettings(PAGE_NAMES.PRIVACY);
        }
    };

    cancel = () => {
        this.props.getSettings(PAGE_NAMES.PRIVACY);
    };

    render() {
        const { t } = this.props;
        return (
            <div className="row user-settings__cancel-save-button">
                <div className="col-md-12">
                    <div className="pull-right">
                        <Button onClick={this.cancel} className="btn settings-btn-basic" id="cancelButton">{t(['common:cancel', 'Cancel'])}</Button>
                        <Button onClick={this.save} className="btn settings-btn-primary" id="saveButton">{t(['common:save', 'Save'])}</Button>
                    </div>
                </div>
                {this.state.isConsentConflictModalVisible && <ConsentConflictModal hideConsentConflictModal={() => { this.setState({isConsentConflictModalVisible: false}); }} />}
            </div>
        );
    }
}

CancelSaveButton.propTypes = {
    t: PropTypes.func,
    settings: PropTypes.object,
    apiUrl: PropTypes.string,
    getSettings: PropTypes.func,
    saveSettings: PropTypes.func
};

const mapStateToProps = (state) => {
    if (!state.settings.current) {
        return {};
    }

    return {
        name: state.settings.current,
        settings: state.settings[state.settings.current]
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSettings: (name) => dispatch(getSettings(name)),
        saveSettings: (name) => dispatch(saveSettings(name))
    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps), translate(['common'], { wait: true }))(CancelSaveButton);




// WEBPACK FOOTER //
// ./src/UserSettings/components/CancelSaveButton/index.jsx